export default {
  // Navbar
  "nav.home": "Home",
  "nav.about": "About Us",
  "nav.gallery": "Gallery",
  "nav.news": "News",
  "nav.useful": "Resources",
  "nav.programs": "Programs",
  "nav.contact": "Contact",
  "nav.toggle_menu": "Toggle menu",

  // Language Switcher
  "lang.switch_to": "RO",
  "lang.current": "EN",

  // Footer — Brand
  "footer.tagline": "Federation of Fishermen's Organizations of the Black Sea — the representative professional organization of maritime professional fishermen in Romania.",
  "footer.nav_title": "Quick Links",
  "footer.legal_title": "Legal",
  "footer.contact_title": "Contact",

  // Footer — quick links
  "footer.link_home": "Home",
  "footer.link_about": "About Us",
  "footer.link_gallery": "Gallery",
  "footer.link_news": "News",
  "footer.link_programs": "Programs",
  "footer.link_contact": "Contact",
  "footer.link_fishing": "Romanian Fishing",
  "footer.link_fishermen": "Professional Fishermen",
  "footer.link_gastronomy": "Seafood Gastronomy",
  "footer.link_calcan": "Turbot",

  // Footer — legal links
  "footer.link_statute": "FOPMN Statute",
  "footer.link_privacy": "Privacy Policy",
  "footer.link_cookies": "Cookie Policy",
  "footer.link_terms": "Terms and Conditions",

  // Footer — contact
  "footer.address": "11 Smaraldului St., Apt. 6, Constanța, Constanța County, Postal Code: 900001",
  "footer.phone_president": "0723 633 364",
  "footer.email_president": "Lmirea@ymail.com (President)",
  "footer.email_official": "office@federatiapescarilormareaneagra.ro",

  // Footer — copyright
  "footer.copyright": "FOPMN — Federation of Fishermen's Organizations of the Black Sea. All rights reserved.",
  "footer.created_by": "Created by web design agency",

  // Cookie Banner
  "cookie.text": "Our website uses essential cookies for functionality and anonymous analytics cookies to understand how visitors interact with our content. We do not use marketing cookies and we do not share your data with third parties.",
  "cookie.essential": "Essential Only",
  "cookie.accept_all": "Accept All",
};